import { get } from "lodash";
import "./rewrite-url-img.service";
import { thor } from "../../typings/thor";

class RewriteUrlImgFilter {

    public static $inject: string[] = ["rewriteUrlImg"];

    constructor(rewriteUrlImg) {
        return (originalUrl, parameters) => {
            const rewriteUrlParameters: thor.RewriteUrlImgParameters = {
                width: parameters.width,
                height: parameters.height,
                cropMode: parameters.cropMode,
                transform: get(parameters, "meta.transform", null)
            };

            return rewriteUrlImg.buildUrl(originalUrl, rewriteUrlParameters);
        };
    }
}

angular
    .module("thor.core.images.rewriteUrlImg.filter", [
        "thor.core.images.rewriteUrlImg.service"
    ])
    .filter("rewriteUrlImg", <any>RewriteUrlImgFilter);
